var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.6,
    height: 19.6,
    viewBox: "0 0 19.6 19.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3230",
    "data-name": "Group 3230",
    transform: "translate(-309.2 -831.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_161",
    "data-name": "Line 161",
    d: "M0,12.255a.8.8,0,0,1-.8-.8V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V11.455A.8.8,0,0,1,0,12.255Z",
    transform: "translate(319 835.272)",
    fill: "#52ff02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1753",
    "data-name": "Rectangle 1753",
    d: "M3.273-.8H14.727A4.078,4.078,0,0,1,18.8,3.273V14.727A4.078,4.078,0,0,1,14.727,18.8H3.273A4.078,4.078,0,0,1-.8,14.727V3.273A4.078,4.078,0,0,1,3.273-.8Zm11.454,18A2.476,2.476,0,0,0,17.2,14.727V3.273A2.476,2.476,0,0,0,14.727.8H3.273A2.476,2.476,0,0,0,.8,3.273V14.727A2.476,2.476,0,0,0,3.273,17.2Z",
    transform: "translate(310 832)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_160",
    "data-name": "Line 160",
    d: "M0,6.527a.8.8,0,0,1-.8-.8V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V5.727A.8.8,0,0,1,0,6.527Z",
    transform: "translate(314.092 841)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_162",
    "data-name": "Line 162",
    d: "M0,8.164a.8.8,0,0,1-.8-.8V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V7.364A.8.8,0,0,1,0,8.164Z",
    transform: "translate(323.908 839.363)",
    fill: "#16161a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.1444c2cfb6bae81c2cf71f059c05d177.svg";
export { ForwardRef as ReactComponent };